import React, { Component } from 'react'
import PropTypes from 'prop-types'

import ContentHolder from '../../ui/ContentHolder'
import styles from './styles.scss'

class StickyLogo extends Component {
  render(){
    const {
      brand: { colour_primary, logo },
    } = this.props

    if (!logo || !logo.small){
      return null
    }

    return (
      <div className={styles.root} style={{ backgroundColor: `#${colour_primary}` || 'white' }}>
        <ContentHolder>
          <span className={styles.logo} style={{ backgroundImage: `url(${logo.small})` }} />
        </ContentHolder>
      </div>
    )
  }
}

StickyLogo.propTypes = {
  brand: PropTypes.object.isRequired,
}

export default StickyLogo
